import { API_PREFIX } from './constant'
import { Request } from './request'

export interface FieldSettingItem {
  fieldName?: string
  fieldCode: string
  required?: boolean
  display?: boolean
  sortOrder?: number
}

export interface MedicalRecordTypeConfig {
  universalVersion?: FieldSettingItem[]
  chineseMedicineVersion?: FieldSettingItem[]
  oralVersion?: FieldSettingItem[]
}

export interface SaveFieldSettingParams {
  configType:number,
  functionType: number,
  templateType:string,
  fields:FieldSettingItem[]
}

export interface getConfigParams {
  configType?:number,
  functionType: number,
  templateType: string
}

export function getFieldSettingList(params: getConfigParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/tenantSysFunFieldConfig/getConfigOfTenant`,
    method: 'GET',
    params,
  }
}

export function saveFieldSetting(body: SaveFieldSettingParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/tenantSysFunFieldConfig/submit`,
    method: 'POST',
    body,
  }
}

export function restoreDefaultSetting(body: getConfigParams): Request {
  return {
    url: `${API_PREFIX}/blade-user/tenantSysFunFieldConfig/restoreDefaultSetting`,
    method: 'POST',
    body,
  }
}
